import React from 'react';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import NotificationIcon from '../NotificationIcon';
import { doActionTemplateId } from '../../methods';
import {
  BUTTON_VARIANT,
  COLOR_CODES,
  NOTIFICATION_ACTION_IDS
} from '../../stubs';
import { ReactComponent as CloseIcon } from 'assets/img/icons/new/banner-close.svg';

export default function NotificationBanner({
  details = {},
  onDismissCb = () => {}
}) {
  const { push } = useHistory();

  const id = _get(details, 'id', '');
  const type = _get(details, 'category', '');
  const title = _get(details, 'title', '');
  const subtitle = _get(details, 'description', '');
  const isDismissable = _get(details, 'is_dismissable', true);
  const actionLabel = _get(details, 'action_label', '');
  const actionId = _get(details, 'action_id', '');

  const takeAction = () => {
    if (!actionId) return;
    doActionTemplateId(actionId, { redirectFn: push });
  };

  const notificationStyle = {
    backgroundColor: COLOR_CODES[type],
    borderColor: COLOR_CODES[type]
  };

  const buttonVariant = BUTTON_VARIANT[type] || 'outline';

  const showActionButton = actionLabel && actionId in NOTIFICATION_ACTION_IDS;

  const onDismiss = () => {
    if (!id) return;
    onDismissCb(id);
  };

  return (
    <div className={styles.notificationBody} style={notificationStyle}>
      <div className="d-flex align-items-center">
        <NotificationIcon type={type} />
        <div className="ml-3">
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
      </div>
      <div className={styles.actionCol}>
        <If test={showActionButton}>
          <UiKit.Button
            onClick={takeAction}
            variant={buttonVariant}
            className={styles.button}
          >
            {actionLabel}
          </UiKit.Button>
        </If>
        <If test={isDismissable}>
          <CloseIcon onClick={onDismiss} />
        </If>
      </div>
    </div>
  );
}
